'use client';
/**
 * Проверяет, доступен ли `window.matchMedia` (media-запросы) в текущем контексте.
 */ var isMatchMediaAvailable = function() {
    return "matchMedia" in (window || {});
};

export { isMatchMediaAvailable };
